import { Phone } from 'lucide-react';
import { useVoice } from '@/context/VoiceContext';
import { normalizePhone, isMobileDevice } from '@/lib/phone';

/**
 * Clickable phone number. Desktop: loads the number into Quick Dial ready to
 * call (Alian: "el marcador debe abrir con ese número cargado") — the user still
 * presses Call, so a stray click never places a real Twilio call.
 * Mobile: opens the native dialer with the number prefilled.
 */
export default function PhoneLink({ number, name, testId, className = '', showIcon = true, children }) {
  const { requestDial } = useVoice();
  if (!number) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    if (isMobileDevice()) return; // let the tel: href open the native dialer
    e.preventDefault();
    requestDial(normalizePhone(number), name || number, false);
  };

  return (
    <a
      href={`tel:${normalizePhone(number)}`}
      onClick={handleClick}
      title={`Call ${name || number}`}
      data-testid={testId}
      data-phone={normalizePhone(number)}
      className={`inline-flex items-center gap-1 text-[#003366] hover:underline ${className}`}
    >
      {showIcon && <Phone className="w-3 h-3 flex-shrink-0" />}
      {children || number}
    </a>
  );
}
